export class GrnIdReq{
    grnId:number
    constructor(grnId:number){
        this.grnId = grnId
    }
}

export class RmDateReq{
    invoiceFromDate:any
    invoiceToDate:any
    noOfDays:number
    model:string
    unit?:number
    supplierId?:number
    vendorId?:number
    buyerId?:number
    company?:any
    year?:number
    month?:number
    constructor(
        invoiceFromDate?:any,
        invoiceToDate?:any,
         noOfDays?:number,
        model?:string,unit?:number,supplierId?:number,
        vendorId?:number,buyerId?:number,company?:any,
            year?:number,
    month?:number


    ){
        this.invoiceFromDate = invoiceFromDate
        this.invoiceFromDate = invoiceToDate
        this.noOfDays = noOfDays
         this.model = model
         this.unit = unit
         this.supplierId = supplierId
         this.vendorId = vendorId
         this.buyerId = buyerId
         this.company=company
         this.year=year
         this.month=month
    }
}